<template>
  <div v-if="success">
    <div v-if="meta.lifetimeaccess">
      <div class="py-6 px-4 sm:p-6 lg:pb-8">
        <div>
          <h2 class="text-lg leading-6 font-medium text-gray-900">
            Studio Plan
          </h2>
          <p class="mt-1 text-sm text-gray-500">
            Nutze das St. Audio Studio im kostenlosen Basic-Plan oder mit vollem Funktionsumfang im Pro-Plan für einen, zwei oder beliebig viele Podcasts.
          </p>
        </div>
        <div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-4 my-8 shadow-md" role="alert">
          <div class="flex">
            <div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
            <div>
              <p class="font-bold">Dauerhafter Zugriff freigeschaltet</p>
              <p class="text-sm">Danke für deinen frühen Support von St. Audio beim Crowdfunding! Mit deinem Lifetime-Plan kannst du fortlaufend auf alle aktuellen und zukünftigen Basic- und Pro-Features vom Studio zugreifen und mit deinem Podcast kontinuierlich wachsen.</p>
            </div>
          </div>
        </div>
        <div class="mt-6 flex flex-col" >
          <LifetimeAccess :offering="lta" />
        </div>
      </div>

    </div>
    <div v-if="!meta.lifetimeaccess">
      <div class="py-6 px-4 sm:p-6 lg:pb-8">
        <div>
          <h2 class="text-lg leading-6 font-medium text-gray-900">
            Studio Upgrade
          </h2>
          <p class="mt-1 text-sm text-gray-500">
            Nutze das St. Audio Studio im kostenlosen Basic-Plan oder mit vollem Funktionsumfang im Pro-Plan für einen, zwei oder beliebig viele Podcasts.
          </p>
        </div>
        <div class="mt-6 flex flex-col" >
          <PricingPlanAccount :offering="owned" />
        </div>
      </div>

      <div class="py-6 px-4 sm:p-6 lg:pb-8">
        <div>
          <h2 class="text-lg leading-6 font-bold text-gray-900">
            Studio Pro
          </h2>
          <p class="mt-1 text-sm text-gray-500">
            Verknüpfe deinen Podcast jederzeit mit einem Pro-Plan für das Studio. Für die Verifizierung und Abrechnung arbeiten wir mit der Berliner Mitgliedschaftsplattform Steady.
          </p>
        </div>
        <div class="mt-6 flex flex-col" >
          <PricingPlanAccount v-for="o in other" :key="o.tier" :offering="o" />
        </div>
      </div>
    </div>

    <div v-if="!meta.lifetimeaccess" class="py-6 px-4 sm:p-6 lg:pb-8">
      <ConnectAccount :steadyEmail="steadyEmail" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useFetchResources } from '@/client/actions';
import { useStore } from 'vuex';

const store = useStore();

const steadyEmail = computed(() => store.getters['auth/user'].steady_user_email);

const target = computed(() => '/api/account/offerings');

const action = useFetchResources(target);

const { results, meta, fetching, fetch, success } = action;

const lta = {"tier":"pro_any","name":"Beliebig viele Podcasts","summary":"Schalte alle interaktiven Features für beliebig viele Podcasts frei und wachse mit KI-Anleitung","steady":"https://steadyhq.com/de/plans/54dd343c-c86e-4034-910c-c3685b1b944f","features":["Studio Pro für beliebig viele Podcasts","Angabe von priorisierten Wachstumszielen","Empfehlungen vom „Kompass“ KI-Assistenten","Personalisierung von Empfehlungen nach Wachstumsphase, sowie Geld- und Zeiteinsatz","Zugriff auf Experimente inkl. Anleitung","Benachrichtigungen per E-Mail","Indie-Support für die Weiterentwicklung","Jederzeit kündbar"]};
const owned = computed(() => results.value.filter(x => x.subscribed)[0]);
const other = computed(() => results.value.filter(x => !x.subscribed && !x.free));

const mounted = onMounted(fetch);
</script>
